import React, { Component } from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';

import UserStore from '../../stores/UserStore';

class PrivateRoute extends Component {
  render() {
    let {
      component: Component,
      ...rest
    } = this.props;

    return (
      <Route {...rest} render={
        (props) => {
          if (UserStore.isAuthenticated()) {
            return (
              <Component {...props} />
            );
          } else {
            return (
              <Redirect to={{
                pathname: '/auth/login',
                state: { from : props.location.pathname },
              }} />
            )
          }
        }} />
    );
  }
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/Auth/PrivateRoute.js